module.exports = __webpack_public_path__ + "static/media/done.6ed5f133.svg";